module.exports = __webpack_public_path__ + "media/audio21.e1953b7d.mp3";